var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lenti"}},[_c('el-row',{staticClass:"lenti-vista-sole"},[(_vm.tipoLenti == 'V')?_c('el-col',{staticClass:"lenti-vista"},[_c('LentiVista')],1):_c('el-col',{staticClass:"lenti-sole"},[_c('LentiSole')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }